//@flow
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import LocationGeocodeEditSelectors from 'common/redux/selectors/locationGeocodeEdit';
import { withRouter } from 'common/components/core/router';
import GroupedLocationCard from 'common/entity/locationMaster/GroupedLocationCard';

const mapStateToProps = (state, props) => {
    const isEditGroupInProgress = LocationGeocodeEditSelectors.getIsEditingLocationGroup(
        state,
        props
    );
    const isVerifyGroupInProgress = LocationGeocodeEditSelectors.getIsVerifyingLocationGroup(
        state,
        props
    );
    return {
        isEditInProgress: isEditGroupInProgress,
        isVerifyInProgress: isVerifyGroupInProgress
    };
};

const GroupedLocationCardContainer = compose(
    withRouter,
    connect(mapStateToProps)
)(GroupedLocationCard);

export default GroupedLocationCardContainer;
